<ui-switch
	class="filterSwitch d-inline-flex"
	[class.unset]="[null, undefined].includes(switchFilterValue)"
	[size]="'small'"
	[checked]="!!switchFilterValue"
	(change)="onSwitchChange($event)"
></ui-switch>
